import {
  EventBusInterceptor,
  UseService,
  ApiServiceHandler
} from '@haskoning/js-api-authentication-management'

import API from '@/api/apiUrls'
import { useEventsBus } from '@haskoning/vue-component-library'

export const { emit } = useEventsBus()

const interceptor = new EventBusInterceptor(emit)

const baseURL = import.meta.env.VITE_APP_API_BASE_URL
const apiServiceHandler = new ApiServiceHandler(
  baseURL,
  API.TOKEN.ACCESS,
  API.TOKEN.REFRESH,
  interceptor
)

export const useApi = () => {
  const api = new UseService(apiServiceHandler)
  return { api }
}
